import React from "react";
import { useNavigate } from "react-router-dom";
import * as Icons from "lucide-react";
import { faltaTxt } from "@/lib/inicio";
import { Personas } from "@/components/personas/Avatar";

export const ProximasFechas = ({ items }) => {
  const navigate = useNavigate();
  if (!items.length) return null;
  return (
    <section className="space-y-3" data-testid="home-proximas">
      <h2 className="font-heading text-xl font-bold text-[#1C2421]">Próximas fechas</h2>
      <ul className="bg-white border border-[#E5DFD5] rounded-2xl divide-y divide-[#F2EDE4]">
        {items.slice(0, 3).map((i) => (
          <li key={i.id}>
            <button data-testid={`proxima-item-${i.id}`} onClick={() => navigate(i.ruta)} className="w-full text-left px-4 py-3.5 flex items-center gap-3 hover:bg-[#FAF8F5]">
              <div className="flex-1 min-w-0">
                <p className="font-heading font-bold text-lg text-[#1C2421]">{i.titulo}</p>
                <p className="text-base text-[#4A5550]">{i.linea}</p>
                <Personas ids={i.personas} />
                <p className="text-base font-bold text-[#3A6B56]">{faltaTxt(i.fecha)}</p>
              </div>
              <Icons.ChevronRight size={20} className="text-[#C4BDB0] shrink-0" />
            </button>
          </li>
        ))}
      </ul>
      <button data-testid="home-ver-proximas" onClick={() => navigate("/agenda")} className="min-h-[48px] text-base font-semibold text-[#3A6B56] inline-flex items-center gap-1">
        Ver la agenda <Icons.ChevronRight size={18} />
      </button>
    </section>
  );
};
